/* istanbul ignore file */
import type {Document} from '@contentful/rich-text-types';

/** In reality not correct Document-like structure, but still used in API and added for combitability */
export type DocumentLike = Record<string, unknown>;
/** Same like DocumentLike, but readonly */
export type ReadonlyDocumentLike = {readonly [x: string]: never};
/** Possible structures that can be casted to document. */
export type AcceptableDocument = Document | DocumentLike | ReadonlyDocumentLike;

/** Preforms only high level check, so if not a real document will fail durign rendering */
export const isDocument = (
  documentLike?: AcceptableDocument,
): documentLike is Document => {
  return !!documentLike?.nodeType;
};

export {BLOCKS} from '@contentful/rich-text-types';
